import React from 'react';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';
import { hasRelationship } from 'Helpers/Affordances';
import Content from './Content';


export function handleRelationshipNavigation(resource, relationshipName, loadPageContentLink, history) {
  const _relationship = resource.relationship(relationshipName);
  const _hasRelationship = hasRelationship(resource, relationshipName);
  async function handleNavigation() {
    if (!_hasRelationship) return;

    const relationshipLink = _relationship.link('related');

    if (_relationship.meta('type') === 'pageSelfLink') {
      await loadPageContentLink(relationshipLink);
    } else {
      history.push(relationshipLink.attr('url'));
    }
  }

  return [handleNavigation, _hasRelationship];
}

export default function ACHTransferSelectAccountTemplate({ resource }) {
  const { loadPageContentLink } = usePageContentContext();
  const history = useHistory();

  const [handleSpecificPageLinkClick, hasSpecificPageLinkRelationship] = handleRelationshipNavigation(resource, fr.relationships.specificPageLink.name, loadPageContentLink, history);
  const [handleCloseClick, hasRedirectOnCloseRelationship] = handleRelationshipNavigation(resource, fr.relationships.redirectOnClose.name, loadPageContentLink, history);


  return <>
    <WizardStepWrapperTemplate
      layout={Content}
      resource={resource}
      LayoutProps={{ resource }}
      metaOverrideSet={BaseWizardStepOverride}
      onSpecificLinkClicked={hasSpecificPageLinkRelationship ? handleSpecificPageLinkClick : undefined}
      onClose={hasRedirectOnCloseRelationship ? handleCloseClick : undefined}
    />
  </>;
}
